import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Languages, Users, Heart, User, Home } from "lucide-react";

const BottomTabNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  
  // Check user's primary language to determine which tabs to show
  const primaryLanguage = localStorage.getItem('passportTalk_primaryLanguage') || 'en';
  const isEnglishUser = primaryLanguage === 'en';

  // Tab configuration - non-English users get simplified nav (no Agents tab)
  const tabs = isEnglishUser ? [
    { path: "/home", icon: Home, labelKey: "nav.home", testId: "home-tab" },
    { path: "/agents", icon: Users, labelKey: "nav.agents", testId: "agents-tab" },
    { path: "/favorites", icon: Heart, labelKey: "nav.favorites", testId: "favorites-tab" },
    { path: "/profile", icon: User, labelKey: "nav.profile", testId: "profile-tab" },
  ] : [
    { path: "/conversation", icon: Languages, labelKey: "nav.translate", testId: "translate-tab" },
    { path: "/favorites", icon: Heart, labelKey: "nav.favorites", testId: "favorites-tab" },
    { path: "/profile", icon: User, labelKey: "nav.profile", testId: "profile-tab" },
  ];

  // Check if current path is translate-related for active state
  const isTranslateActive = ["/home", "/scenarios", "/translate", "/conversation"].includes(location.pathname);
  // Check if current path is agent-related for active state
  const isAgentActive = location.pathname.startsWith("/agents") || location.pathname.startsWith("/booking");

  return (
    <div className={`fixed bottom-6 left-4 right-4 bg-white/90 backdrop-blur-xl border border-white/20 shadow-2xl rounded-2xl flex justify-around items-center h-16 z-50 ${i18n.language === 'ar' ? 'flex-row-reverse' : ''}`}>
      {tabs.map((tab) => {
        const Icon = tab.icon;
        let isActive = false;
        
        if (tab.path === "/home" || tab.path === "/conversation") {
          isActive = isTranslateActive;
        } else if (tab.path === "/agents") {
          isActive = isAgentActive;
        } else {
          isActive = location.pathname === tab.path;
        }
        
        return (
          <button
            key={tab.path}
            onClick={() => navigate(tab.path)}
            className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
              isActive ? "text-aviation" : "text-slate-400 hover:text-slate-600"
            }`}
            data-testid={tab.testId}
          >
            <Icon className="w-6 h-6" strokeWidth={1.5} />
            <span className="text-xs mt-1 font-medium">{t(tab.labelKey)}</span>
          </button>
        );
      })}
    </div>
  );
};

export default BottomTabNav;
